export default __webpack_public_path__ + "static/media/wifi6.9b6b9558.png";